import {Box} from "@mui/material";
import React from "react";

export default function BlurOverlayForBox() {
    return (
        <Box
            sx={{
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backdropFilter: 'blur(2px)',
                zIndex: 10,
                borderRadius: 'inherit',
                cursor: 'not-allowed',
            }}
        />
    );
}